/* (ignored) */


//////////////////
// WEBPACK FOOTER
// stream (ignored)
// module id = 1344
// module chunks = 0